module.exports = __webpack_public_path__ + "media/Son-in-law.e4ce07b3.mp3";